module.exports = __webpack_public_path__ + "img/6d1adad4a3fa4f9703cf9c5ec15412a7.png";